import * as web2client from '../../helpers/web_to_client'

export const handlers = {
    playSound: ({ soundId }) => web2client.playSound(soundId),
    sendNotification: ({ type, message, header }) => web2client.sendNotification(type, message, header),
    buildingUpgraded: ({ buildingName, buildingLevel }) => web2client.strongholdBuildingUpgraded(buildingName, buildingLevel),
    error: ({ errorMessage, statusCode }) => web2client.sendErrorNotification(errorMessage, statusCode),
    openBrowser: ({ url, title, width, height, isModal, showCreateWaiting }) => web2client.openBrowser(url, title, width, height, isModal, showCreateWaiting),
    openBattleRooms: web2client.openStrongholdsBattleRoom,
    openWindow: ({ windowId }) => web2client.openWindow(windowId),
    closeWindow: ({ windowId }) => web2client.closeWindow(windowId),
    closeLeaderboard: web2client.closeLeaderboard,
    battleChosen: web2client.strongholdsBattleChosen,
    openHangar: web2client.openHangar,
    joinToUnitOnOtherPeriphery: ({ unitServerId, peripheryId }) => web2client.joinToStrongholdsBattleOnOtherPeriphery(unitServerId, peripheryId),
    defaultHandler() {
        return null
    },
}

function flatten(array){
    return [].concat.apply([], array)
}

let showDeprecationWarning = true
/**
 * **@deprecated since version 2.0, will be deleted in version 4.0
 * use import * as web2client from 'react-wot-bootstrap/lib/helpers/web_to_client' instead**
 */
export default function webToClient() {
    if (showDeprecationWarning) {
        // eslint-disable-next-line no-console
        console.warn('webToClient middleware is deprecated, will be removed in version 4.0')
        showDeprecationWarning = false
    }

    return next => action => {
        // webToClient attribute can be array or object
        let webToClientData = []
        if (action.meta && action.meta.webToClient) {
            webToClientData = action.meta.webToClient
        }

        const commands = flatten([webToClientData])
        for (let command of commands) {
            if (typeof command === 'object') {
                let handler = handlers.defaultHandler
                if (handlers[command.handler]) {
                    handler = handlers[command.handler]
                } else {
                    // eslint-disable-next-line no-console
                    console.warn(`Web to client handler "${command.handler}" did not found`)
                }

                handler(command.params)
            }
        }

        return next(action)
    }
}



// WEBPACK FOOTER //
// ../node_modules/react-mt-bootstrap/lib/state/middlewares/web_to_client.js